// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2OA89","productName":"Table_productName__22AbR"};